import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import * as insight360Actions from '../../actions/insight360Actions';
import { PREFERENCE_BRAND_CATALYST,
  PREFERENCE_BRAND_CATALYST_STUDY_FAMILY } from '../../constants';

const bcStudyFamily = `${PREFERENCE_BRAND_CATALYST}.${PREFERENCE_BRAND_CATALYST_STUDY_FAMILY}`;


class PreferencesCommonProfileAttitudeList extends Component {
  constructor(props) {
    super(props);
    const { field, bcStudies } = this.props;
    const defaultval = this.getKeyData(field.dbKey);
    let studyFamilyId = this.getKeyData(bcStudyFamily);
    if (studyFamilyId === -1 || studyFamilyId === undefined) {
      studyFamilyId = bcStudies[0].id;
    }
    const UnCheckedValList = this.getAttitudeListBasedOnStudy(defaultval, studyFamilyId);
    this.state = {
      profileAttitudeList: [],
      studyFamilyId,
      unCheckedModuleList: defaultval,
      unCheckedVal: UnCheckedValList,
    };
  }

  componentDidMount() {
    const { field } = this.props;
    const productNo = this.getProductNoFromStudyFamily();
    if (field.action !== undefined) {
      this.props.insight360Actions[field.action.name](productNo, this.callback);
    }
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { field, modifiedPreferences, bcStudies } = this.props;
    const { studyFamilyId, unCheckedVal, unCheckedModuleList } = this.state;

    if (modifiedPreferences !== nextProps.modifiedPreferences) {
      const changedUnCheckedModuleList = this.getKeyData(field.dbKey, false, nextProps.modifiedPreferences);
      let changedStudyFamilyId = this.getKeyData(bcStudyFamily,
      false, nextProps.modifiedPreferences);
      const changedUnCheckedVal = this.getAttitudeListBasedOnStudy(changedUnCheckedModuleList, changedStudyFamilyId);
      if (changedStudyFamilyId === -1 || changedStudyFamilyId === undefined) {
        changedStudyFamilyId = bcStudies[0].id;
      }
      if (studyFamilyId !== changedStudyFamilyId) {
        const productNo = this.getProductNoFromStudyFamily(nextProps.modifiedPreferences);
        this.props.insight360Actions[this.props.field.action.name](productNo, this.callback);
      }
      if (!_.isEqual(unCheckedVal, changedUnCheckedVal) || 
        !_.isEqual(unCheckedModuleList, changedUnCheckedModuleList) ||
        studyFamilyId !== changedStudyFamilyId) {
        this.setState({
          unCheckedModuleList: changedUnCheckedModuleList,
          studyFamilyId: changedStudyFamilyId,
          unCheckedVal: changedUnCheckedVal,
        });
      }
    }
  }


  getProductNoFromStudyFamily = newData => {
    const { bcStudies } = this.props;
    let familySelectedId;
    if (newData === undefined) {
      familySelectedId = this.getKeyData(bcStudyFamily);
    } else {
      familySelectedId = this.getKeyData(bcStudyFamily, false, newData);
    }
    familySelectedId = familySelectedId !== undefined ? familySelectedId : -1;
    const selectedStudies = _.find(bcStudies, { id: familySelectedId });
    const productNo = _.isEmpty(selectedStudies) ? bcStudies[0].sl[0].pn :
        selectedStudies.sl[0].pn;
    return productNo;
  }


  getKeyData = (key, defaultData, newData) => {
    const { modifiedPreferences, userPreference } = this.props;
    const keys = key.split('.');
    let dataKey;
    if (newData !== undefined) {
      dataKey = newData;
    } else {
      dataKey = defaultData ? userPreference : modifiedPreferences;
    }
    return !_.isEmpty(dataKey) ? dataKey[keys[0]][keys[1]] : undefined;
  }

  callback = data => {
    this.setState({ profileAttitudeList: data });
  }

  handleElementClick = (element, index) => {
    const { unCheckedModuleList, unCheckedVal } = this.state;
    const modifiedNode = _.cloneDeep(unCheckedModuleList);
    let selectedNodeAttList = _.cloneDeep(unCheckedVal);

    if (!_.isEmpty(selectedNodeAttList) &&
    selectedNodeAttList.some(item => item.label.includes(element.label))) {
      selectedNodeAttList = selectedNodeAttList.filter(el => el.label !== element.label);
    } else {
      selectedNodeAttList.splice(index, 0, element);
    }
    if (_.findIndex(modifiedNode, { studyFamilyId: this.state.studyFamilyId }) > -1) {
      const indexVal = _.findIndex(modifiedNode, { studyFamilyId: this.state.studyFamilyId });
      modifiedNode[indexVal].profileAttStatements = selectedNodeAttList;
    } else {
      const obj = { studyFamilyId: this.state.studyFamilyId, profileAttStatements: selectedNodeAttList };
      modifiedNode.push(obj);
    }
    this.props.updatePreferences(this.props.field.dbKey,
      modifiedNode
      );
  }

  getAttitudeListBasedOnStudy = (list, studyFamilyId) => {
    if (list !== undefined && !_.isEmpty(list)) {
      const selectedAttList = _.find(list, { studyFamilyId });
      const selectedStudyAttList = selectedAttList !== undefined ? selectedAttList.profileAttStatements : [];
      return selectedStudyAttList;
    } 
      return [];
    
  }


  getCheckedValFlag = element => {
    const { unCheckedVal } = this.state;
    if (unCheckedVal !== undefined) {
      const flag = unCheckedVal.some(item => item.label === element.label);
      return !flag;
    }
  }

  render() {
    const { field } = this.props;
    const { profileAttitudeList, unCheckedModuleList } = this.state;
    return (
      <div className="preference-common-list">
        {!_.isEmpty(profileAttitudeList) &&
        <div
          className="preference-common-list-container profile-attitude-dropdown"
          style={{ width: field.style && field.style.menuWidth,
          paddingRight: field.style && field.style.padding }}
        >
          {profileAttitudeList.map((element, index) => (
            <div
              key={element.label}
              className="preference-common-list-menu"
              onClick={() => this.handleElementClick(element, index)}
            >
              <input
                type="checkbox"
                checked={_.isEmpty(unCheckedModuleList) ? true :
                  this.getCheckedValFlag(element)}
              />
              <label className="preference-common-list-menu-label">{element.label}</label>
            </div>
          ))}
        </div>
        }
      </div>
    );
  }
}

PreferencesCommonProfileAttitudeList.propTypes = {
  field: PropTypes.shape({
    values: PropTypes.arrayOf(PropTypes.shape({})),
    defaultValue: PropTypes.arrayOf(PropTypes.string),
    dbKey: PropTypes.string,
    action: PropTypes.arrayOf(PropTypes.shape({})),
    style: PropTypes.shape({
      menuWidth: PropTypes.string,
      padding: PropTypes.string,
    }),
  }),
  updatePreferences: PropTypes.func,
  // scStudies: PropTypes.arrayOf(PropTypes.shape({})),
  bcStudies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    sl: PropTypes.arrayOf(PropTypes.shape({
      pn: PropTypes.number
    }))
  })),
  modifiedPreferences: PropTypes.shape({}),
  userPreference: PropTypes.shape({}),
  insight360Actions: PropTypes.shape({}),
};

function mapStateToProps(state) {
  return {
    userPreference: state.preferences.userPreferences,
    insight360Study: state.study.insight360study,
    scStudies: state.study.salesCatalystStudies,
    bcStudies: state.study.insight360studies,
  };
}


function mapDispatchToProps(dispatch) {
  return {
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
  };
}

export default connect(mapStateToProps,
  mapDispatchToProps,
  )(PreferencesCommonProfileAttitudeList);
